'use client';

/**
 * Horizontal sliding bar spinner
 *
 * A minimal loading indicator that shows a bar sliding back and forth.
 * Good for indicating content updates without being too prominent.
 *
 * Usage:
 *   <SliderSpinner />                   // Default (primary color, 2px)
 *   <SliderSpinner height={3} />        // 3px tall
 *   <SliderSpinner color="bg-red" />    // Custom color class
 *   <SliderSpinner width="w-32" />      // Custom container width
 */
import { c as _c } from "react/compiler-runtime";
const SliderSpinner = t0 => {
  const $ = _c(8);
  const {
    height: t1,
    color: t2,
    width: t3,
    className: t4
  } = t0;
  const height = t1 === undefined ? 2 : t1;
  const color = t2 === undefined ? "bg-primary" : t2;
  const width = t3 === undefined ? "w-full" : t3;
  const className = t4 === undefined ? "" : t4;
  const t5 = `${width} overflow-hidden rounded-full bg-gray-10 ${className}`;
  const t6 = `${height}px`;
  let t7;
  if ($[0] !== t6) {
    t7 = {
      height: t6
    };
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const t8 = `h-full w-1/3 ${color} rounded-full animate-slider`;
  let t9;
  if ($[2] !== t8) {
    t9 = <div className={t8} />;
    $[2] = t8;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  let t10;
  if ($[4] !== t5 || $[5] !== t7 || $[6] !== t9) {
    t10 = <div className={t5} style={t7}>{t9}</div>;
    $[4] = t5;
    $[5] = t7;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  return t10;
};
export default SliderSpinner;